import React from "react";
import CountUp from "@/components/CountUp";
import { STATS } from "@/data/site";
import { Reveal } from "@/components/Reveal";
import { IMG } from "@/data/site";

export default function StatsSection() {
  return (
    <section className="relative py-24 md:py-32 bg-navy overflow-hidden" data-testid="stats">
      <div className="absolute inset-0 opacity-20">
        <img src={IMG.commercial} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-navy/80" />
      </div>
      <div className="max-w-7xl mx-auto px-5 md:px-8 relative z-10">
        <Reveal>
          <div className="text-center mb-14">
            <span className="text-sky text-xs font-semibold tracking-[0.3em] uppercase">Why Choose Us</span>
            <h2 className="font-display text-4xl md:text-5xl font-extrabold text-white mt-3">Numbers That Build Trust</h2>
          </div>
        </Reveal>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.06}>
              <div className="glass-dark rounded-lg p-6 text-center h-full">
                <div className="font-display text-4xl md:text-5xl font-extrabold text-gradient-blue">
                  <CountUp to={s.value} suffix={s.suffix} />
                </div>
                <div className="text-slate-300 text-sm mt-2">{s.label}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
